import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('allowed_on', 'Allowed On', ALLOWED_ON_OPTIONS)
      .multi(true)
      .getValue(formatFilterValueHelper)
      .setValue(formatFilterStateHelper),
    filter
      .options.list('device_type', 'Device Type', DEVICE_TYPE_OPTIONS)
      .multi(true)
      .getValue(formatFilterValueHelper)
      .setValue(formatFilterStateHelper),
    filter.boolean('custom_continue', 'Custom Continue'),
    filter.boolean('disable_continue_button', 'Disable Continue Button'),
    filter.boolean('active', 'Active'),
  ], [])
}

const ALLOWED_ON_OPTIONS = [
  { label: "Pages", value: "pages" },
  { label: "Allocations", value: "allocations" },
]

const DEVICE_TYPE_OPTIONS = [
  { label: "Mobile", value: "mobile" },
  { label: "Desktop", value: "desktop" },
]

const formatFilterValueHelper = value => {
  if (value && value["$or"] && value["$or"][1]["$overlap"] && value["$or"][1]["$overlap"].length) {
    return value["$or"][1]["$overlap"]
  }
  return undefined
}

const formatFilterStateHelper = value => value.length ? { $or: [null, { $overlap: value }] } : []
